<template>
<div class="timelog-card card mb-2" v-on:click="$emit('click')">
	<div class="card-body">
		<h3 class="card-title">
			<template v-if="timelog.Service">
				Service #{{ timelog.Service.job_num }}
			</template>
			<template v-else-if="timelog.Job">
				Project #{{ timelog.Job.job_num }}
			</template>
		</h3>

		<div class="row">
			<div class="col-sm-6">
				<div v-for="(field, index) in fields" v-if="index < fields.length / 2 && timelog[field.key]">
					<strong>{{ field.label }}: </strong>
					<router-link v-if="typeof timelog[field.key] == 'object' && 'link' in timelog[field.key]" :to="timelog[field.key].link">{{ timelog[field.key].text }}</router-link>
					<span v-else v-html="timelog[field.key]"></span>
				</div>
			</div>
			<div class="col-sm-6">
				<div v-for="(field, index) in fields" v-if="index >= fields.length / 2 && timelog[field.key]">
					<strong>{{ field.label }}: </strong>
					<router-link v-if="typeof timelog[field.key] == 'object' && 'link' in timelog[field.key]" :to="timelog[field.key].link">{{ timelog[field.key].text }}</router-link>
					<span v-else v-html="timelog[field.key]"></span>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script type="text/javascript">
export default {
	name: "TimeLogListCard",
	props: [
		"timelog",
		"fields"
	]
}
</script>

<style type="text/css" scoped>
	.timelog-card:hover {
		cursor: pointer;
		background-color: var(--background-light);
	}
</style>